/**
 * Nomes de permissões usados nas verificações do frontend.
 * Devem ser idênticos aos cadastrados na tabela `permissions` do backend.
 */
export const PERMISSIONS = {
  /** Painel de correção manual de balanços (grupo "Configurações do Sistema"). */
  MANAGE_BALANCE_ADJUSTMENTS: "manage-balance-adjustments",

  /** Tela de acesso como usuário / personificação (grupo "Configurações do Sistema"). */
  IMPERSONATE_USERS: "impersonate-users",

  /** Normalização de vendas inconsistentes (grupo "Configurações do Sistema"). */
  MANAGE_SALE_NORMALIZATION: "manage-sale-normalization",

  /** Enviar e remover comprovantes de devolução (grupo "Devoluções"). */
  UPLOAD_DEVOLUTION_RECEIPT: "upload-devolution-receipt",

  /** Sangrias (grupo "Sangrias"). */
  VIEW_BLEED_LIST: "view-bleed-list",
  CREATE_BLEED: "create-bleed",
  VIEW_ALL_BLEEDS: "view-all-bleeds",
  APPROVE_BLEED: "approve-bleed",
  REJECT_BLEED: "reject-bleed",
  /** Tela de logs de ações de concursos e vendas (grupo "Configurações do Sistema"). */
  VIEW_ACTION_LOGS: "view-action-logs",
  /**
   * Aba "Resultado Clientes" com todos os vendedores (grupo "Vendas").
   * Vendedor acessa sempre e vê só as próprias vendas (regra também na API).
   */
  VIEW_CLIENT_RESULTS: "view-client-results",

  /**
   * Aba "Endossamento" (grupo "Vendas"). LOT-34
   * Quem só tem "view" vê as próprias solicitações; "review" vê todas e aprova/recusa.
   */
  VIEW_ENDORSEMENT_REQUESTS: "view-endorsement-requests",
  REVIEW_ENDORSEMENT_REQUESTS: "review-endorsement-requests",

  /** Recebe os alertas de % de estoque (grupo "Estoque"). LOT-26 */
  RECEIVE_STOCK_ALERTS: "receive-stock-alerts",

  /** Aba "Premiações Totais": premiações apuradas por concurso (grupo de "Lista de Prêmios"). */
  VIEW_TOTAL_PRIZES: "view-total-prizes",

  /** Banco de Bolões: consultar os jogos cadastrados (grupo "Banco de Bolões"). LOT-62 */
  VIEW_GAME_BANK: "view-game-bank",

  /** Banco de Bolões: cadastrar jogos no banco (grupo "Banco de Bolões"). LOT-62 */
  MANAGE_GAME_BANK: "manage-game-bank",

  /** Formador de Bolões: consultar seleções e gerar PDF (grupo "Banco de Bolões"). LOT-62 */
  VIEW_GAME_SELECTIONS: "view-game-selections",

  /** Formador de Bolões: montar, editar, duplicar e excluir seleções (grupo "Banco de Bolões"). LOT-62 */
  MANAGE_GAME_SELECTIONS: "manage-game-selections",

  /** Gerar relatório "Compras Clientes" (tela Gerar Relatório). */
  VIEW_CUSTOMER_PURCHASES_REPORT: "view-customer-purchases-report",
} as const;
